import { Trans, useLingui } from '@lingui/react/macro';

import { ActivityOfType } from '@/components/activities/Activity';
import {
  BaseActivity,
  BaseActivityArticleName,
  BaseActivityDetailedContent,
  BaseActivityText,
} from '@/components/activities/BaseActivity/BaseActivity';
import InlineText from '@/design_system/Typography/InlineText';
import IconInfo from '@/icons/Info.svg';
import { WARRANTY_OVERRIDE_REASONS } from '@/models/article';

export const ArticleWarrantyForcedActivity = ({
  activity,
  displayArticleName,
}: {
  activity: ActivityOfType<'article_warranty_forced'>;
  displayArticleName: boolean;
}) => {
  const { i18n } = useLingui();
  const creatorName = activity.creator.name;
  const reason = WARRANTY_OVERRIDE_REASONS.find((reason) => reason.id === activity.data.reason);
  const reasonMessage = reason ? i18n._(reason.text) : undefined;

  return (
    <BaseActivity
      key={activity.id}
      createdAt={activity.createdAt}
      icon={<IconInfo />}
      message={
        <BaseActivityText>
          <Trans id="activities.article-warranty-forced.message">
            <InlineText weight="medium">{creatorName}</InlineText> forced warranty activation on the
            item{' '}
            <BaseActivityArticleName activity={activity} displayArticleName={displayArticleName} />
          </Trans>
        </BaseActivityText>
      }
    >
      {!!reasonMessage && (
        <BaseActivityDetailedContent>
          <Trans id="activities.article-warranty-forced.message.reason">
            Reason: {reasonMessage}
          </Trans>
        </BaseActivityDetailedContent>
      )}
    </BaseActivity>
  );
};
